import React from "react";

interface Props {
  className?: string;
  color?: string;
}

const ImageIcon: React.FC<Props> = ({className, color}) => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      className={className}
      d="m8.5 13.5 2.5 3 3.5-4.5 4.5 6H5l3.5-4.5ZM21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2Z"
      fill={color || "#FF9800"}
    />
  </svg>
);

export default ImageIcon;
